/**
 * Parallax Funktionalität für Slider hinzufügen
 *
 * Es wir ein Parallax Effekt hingefügt und berücksichtigt, dass Elemente über dem Slider (prev all der Section) die
 * nicht sticky sind, sowie einen Margin-Top oder Padding-Top haben, dass verschieben für die Höhe aussetzen.
 *
 * Events: window.load, window.scroll
 *
 * @param containerSelector jquery Selector für den Parallax Container
 *
 * @return void
 */
function nc_initSliderParallax(containerSelector) {
    var moduleLogger = LoggerManager.get('slider-parallax').setPrefix('Selektor: ' + containerSelector);
    moduleLogger.trace('INIT START');
    moduleLogger.info('Load, Scroll und Lazy Load Action registrieren');
    // Wenn geladen, Bilder geladen, gescrollt wird führe den Parallax Effekt auf den gewählten Selector aus.
    $(window).load(function () {
        nc_SliderParallax(containerSelector);
    });
    $(window).scroll(function () {
        nc_SliderParallax(containerSelector);
    });
    if (amphiEventHandler.hasEvent('lazyload', 'postLoadImage')) {
        amphiEventHandler.lazyload.postLoadImage.addAction(function () {
            nc_SliderParallax(containerSelector);
        });
    }
    moduleLogger.info('INIT ENDE');
}

/**
 * @see nc_initSliderParallax
 */
function nc_SliderParallax(containerSelector) {
    var scrollPos = $(window).scrollTop();
    var offset = 0;
    var positionTo = 0;

    // Berücksichtigt wird, dass Elemente die über der Section liegen und nicht Sticky sind gefunden werden. Der Parallax Effekt setzt für die Höhe der nicht sticky Elemente aus.
    $(containerSelector).parents('section').prevAll().each(function () {
        if ($(this).is(':visible') && $(this).css('visibility') !== 'hidden' && $(this).css('position') !== 'sticky') {
            offset += $(this).outerHeight();
        }
        $(this).children().each(function () {
            if ($(this).is(':visible') && $(this).css('visibility') !== 'hidden' && $(this).css('position') !== 'sticky') {
                offset += $(this).outerHeight();
            }
        });
    });

    // Berücksichtigt wird, dass Elemente die über der Section liegen und einen padding-top und/oder margin-top haben gefunden werden. Der Parallax Effekt setzt für diese Höhe aus.
    $(containerSelector).parents('section').parents().each(function () {
        if ($(this).is(':visible') && $(this).css('visibility') !== 'hidden' && $(this).css('position') !== 'sticky') {
            offset += parseInt($(this).css('margin-top')) + parseInt($(this).css('padding-top'));
        }
    });


    if (scrollPos > offset) {
        positionTo = ((scrollPos - offset) / 2);
    }
    $(containerSelector).css({
        'transform': 'translate3d(0px, ' + positionTo + 'px, 0px)'
    });
    $(containerSelector + ' .caption-wrapper').css({
        'transform': 'translate3d(0px, ' + -1 * positionTo + 'px, 0px)'
    });
}